import type { NotificationOptionsState } from './NotificationOptionSchema';
import { createStore } from 'satcheljs';

const store = createStore<NotificationOptionsState>('notificationOptions', {})();

export default (): NotificationOptionsState => store;
